import {gql} from "@apollo/client";
import {client} from "graphql/client";

export const GET_ACCOUNT_TMS_DRIVER_BY_ACCOUNT_ID = gql`
    query GetAccountTmsDriverByAccountId($accountId: Long!) {
        getAccountTmsDriverByAccountId(accountId: $accountId) {
            id
            accountId
            vehicleId
            carrierId
        }
    }
`;

export interface AccountTmsDriverType {
    id: number;
    accountId: number;
    vehicleId?: number;
    carrierId: number;
    workWeekdaysJson: string;
    workStartTime: string;
    workEndTime: string;
    responsibleZipcodeListJson?: string;
}

interface GetAccountTmsDriverByAccountIdQuery {
    getAccountTmsDriverByAccountId: AccountTmsDriverType;
}

interface GetAccountTmsDriverByAccountIdQueryVariables {
    accountId: number;
}

export const getAccountTmsDriverByAccountId = async (accountId: number): Promise<AccountTmsDriverType> => {
    const {data} = await client.query<GetAccountTmsDriverByAccountIdQuery, GetAccountTmsDriverByAccountIdQueryVariables>({
        query: GET_ACCOUNT_TMS_DRIVER_BY_ACCOUNT_ID,
        variables: {accountId}
    });
    return data.getAccountTmsDriverByAccountId;
}; 